// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/sbg-dynamic-share-price-historical/sbg-dynamic-share-price-historical.component.scss
// module id = 724
// module chunks = 0